import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import formatCustomText from "activityModule/utils/formatCustomTxt";
import { activitySearchRtk } from "activityModule/apis/activitySearchRtk";
import { Spinner } from "react-bootstrap";
import { IDMCActivity } from "commonFnBcode/types/dmc.types";

interface ActivityDescriptionSectionProps {
  description: string;
  enhancedDescription: string;
  onDescriptionChange: (value: string) => void;
  onEnhancedDescriptionChange: (value: string) => void;
  activity: IDMCActivity;
}

function ActivityDescriptionSection({
  activity,
  description,
  enhancedDescription,
  onDescriptionChange,
  onEnhancedDescriptionChange,
}: ActivityDescriptionSectionProps) {
  const [updateActivity, { isLoading }] =
    activitySearchRtk.useUpdateActivityMutation();

  return (
    <div className="mb-4">
      {/* Basic Description Field */}
      <div className="mb-4">
        <div className="d-flex justify-content-start gap-3 align-items-center mb-2">
          <h6 className="m-0 fw-bold text-primary">Description Preview</h6>
          <button
            onClick={() => updateActivity({ id: activity.id, description })}
            disabled={isLoading}
            className="btn btn-primary btn-flat btn-sm py-0"
          >
            {isLoading ? <Spinner /> : "Save"}
          </button>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: formatCustomText(description),
          }}
        />
      </div>
      <div className="mb-4">
        <textarea
          className="form-control"
          rows={16}
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Enter basic activity description..."
        />
      </div>

      {/* <div className="mb-4">
        <label className="form-label fw-bold">
          <i className="fas fa-file-alt me-2"></i>
          Enhanced Description
        </label>
        <div className="border rounded p-1">
          <CKEditor
            editor={ClassicEditor}
            data={enhancedDescription}
            config={{
              toolbar: [
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "|",
                "bulletedList",
                "numberedList",
                "|",
                "outdent",
                "indent",
                "|",
                "blockQuote",
                "insertTable",
                "|",
                "undo",
                "redo",
              ],
              placeholder:
                "Enter detailed activity description with formatting...",
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              onEnhancedDescriptionChange(data);
            }}
          />
        </div>
      </div> */}
    </div>
  );
}

export default ActivityDescriptionSection;
